module.exports = __webpack_public_path__ + "static/img/order_icon2.4b380ec4.svg";